/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_REBATE_PERCENT =
  'GET_REBATE_PROGRAM_REBATE_PERCENT';
export const SET_SELECTED_REBATE_PERCENT = 'SET_SELECTED_REBATE_PERCENT';
export const IS_LOADING_ADJUSTMENT_REBATE_PERCENT =
  'IS_LOADING_ADJUSTMENT_REBATE_PERCENT';
export const GET_MANUFACTURER_LIST_REBATE_PERCENT =
  'GET_MANUFACTURER_LIST_REBATE_PERCENT';
export const FIRST_SUMMARY_VALUE = 'FIRST_SUMMARY_VALUE';

export const GET_DRAMS_QUARTER = 'GET_DRAMS_QUARTER';
export const GET_SEARCH_RESULT_REBATE_PERCENT =
  'GET_SEARCH_RESULT_REBATE_PERCENT';
export const REFRESH_REBATE_PERCENT = 'REFRESH_REBATE_PERCENT';
export const SET_REFRESH_REBATE_PERCENT_DISPLAY =
  'SET_REFRESH_REBATE_PERCENT_DISPLAY';
export const SET_SELECT_ROWS = 'SET_SELECT_ROWS';
export const SET_EXPORT_ALL_REBATE_PERCENT = 'SET_EXPORT_ALL_REBATE_PERCENT';
